import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { ParticipantTabNavs } from "@/shared/components/tabNavs";
import Sidebar from "@/containers/Layout/sidebar";
import ClearPageLayout from "@/containers/Participant/components/ClearPageLayout";
import OurMerchants from "./components/BrowseMerchant";
// import GcmSection from "./components/GcmSection";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { verifyPfiUser } from "@/services/program/getMerchants";

const IMG_BACK = `${process.env.PUBLIC_URL}/theme/classic/img/pages/my-points.jpg`;

const BrowseMerchants = ({ template, program }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [verifyingMerchantId, setVerifyingMerchantId] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const showPfiBanner = program?.pfi?.enable_pfi && program?.pfi_merchant_id;

    const handleBannerClick = async () => {
        await processMerchantClick({ id: program.pfi_merchant_id, is_pfi_merchant: true });
    };

    const processMerchantClick = async (merchant) => {
        if (verifyingMerchantId) return;
        try {
            if (merchant.is_pfi_merchant) {
                setPageLoading(true);
                setVerifyingMerchantId(merchant.id);
                const result = await verifyPfiUser(
                    merchant.pivot?.program_id || program.id,
                    merchant.id
                );
                if (result.status !== '200') {
                    alert(result.message || "User verification required");
                    return;
                }
                if (result?.url) {
                    window.location.href = result.url;
                    return;
                }
            }
        } catch (error) {
            console.error(error);
            alert("Verification failed. Please try again.");
        } finally {
            setVerifyingMerchantId(null);
            setTimeout(() => setPageLoading(false), 500);
        }
    };

    const ClearBrowseMerchants = () => (
        <div className="bm-page">
            <div className="bm-page__header">
                <Container>
                    <div className="bm-page__header-inner">
                        <div>
                            <h1 className="bm-page__title">{t('our_merchants')}</h1>
                            <p className="bm-page__desc">{t('browse_merchant_desc')}</p>
                        </div>
                    </div>
                </Container>
            </div>
            <Container className="bm-page__body">
                <ClearPageLayout>
                    {showPfiBanner && (
                        <div className="bm-page__banner">
                            <img
                                src={`${process.env.REACT_APP_API_STORAGE_URL}/theme/default/images/Rewards-Catalog-Banner.jpg`}
                                alt="Rewards Catalog"
                                onClick={handleBannerClick}
                            />
                        </div>
                    )}
                    {/* <GcmSection /> */}
                    <OurMerchants />
                </ClearPageLayout>
            </Container>
        </div>
    );

    const ClassicBrowseMerchants = () => (
        <>
            <div className="mainboard">
                <img src={IMG_BACK} alt="Redeem" />
                <div className="title">{t("redeem_my_points")}</div>
            </div>
            <Container>
                <ParticipantTabNavs />
            </Container>
            <Container>
                <Row>
                    <Col md={9}>
                        <div className="dashboard">
                            <OurMerchants />
                        </div>
                    </Col>
                    <Col md={3}>
                        <Sidebar />
                    </Col>
                </Row>
            </Container>
        </>
    );

    return (
        <>
            {pageLoading && (
                <div className="full-page-loader">
                    <div className="spinner-border text-primary" role="status" />
                    <p className="mt-3">Please wait…</p>
                </div>
            )}
            {(template?.name === "clear" && <ClearBrowseMerchants />) ||
             (template?.name === "classic" && <ClassicBrowseMerchants />)}
        </>
    );
};

const mapStateToProps = (state) => ({
    template: state.template,
    program: state.program,
});

export default connect(mapStateToProps)(BrowseMerchants);
